module.exports = __webpack_public_path__ + "static/media/phone-web-faded.2f3d254d.png";